import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt, FaYoutube
} from "react-icons/fa";
import "./Footer.css";

import niecceLogo from "../assets/Round Logo - NIECCE NTT.avif";
import roundLogo from "../assets/NIECCE Logos.avif";

const Footer = () => {
  return (
    <footer className="niecce-footer">
      <div className="footer-container">
        {/* 1️⃣ Left: Brand + About */}
        <div className="footer-brand">
          <img
            src={roundLogo}
            alt="NIECCE teacher training institute round logo"
            title="NIECCE teacher training institute"
            className="footer-logo"
          />
          <p>
            <strong>NIECCE</strong> (National Institute of Early Child Care and
            Education) — a premier teacher training institute in Bangalore,
            specializing in <strong>Nursery (NTT)</strong>,{" "}
            <strong>Montessori (MTT)</strong>, and{" "}
            <strong>Primary Teacher Training (PTT)</strong> since 2004.
          </p>
          <div className="social-icons">
             <a href="https://www.instagram.com/niecceinstitute/" target="_blank" aria-label="Instagram">
                          <FaInstagram />
                        </a>
                        <a href="https://www.facebook.com/NIECCEofficial" target="_blank" aria-label="Facebook">
                          <FaFacebookF />
                        </a>
                        <a href="https://www.youtube.com/@nieccentt6307" target="_blank" aria-label="YouTube">
                          <FaYoutube />
                        </a>
          </div>
        </div>

        {/* 2️⃣ Middle: Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li> 
            <li><a href="/Alumni">Alumni</a></li>
            <li><a href="/Partner">Partner</a></li>
            <li><a href="/Events">Events</a></li>
            <li><a href="/blogs">Blog</a></li>
            <li><a href="/Contact">Contact Us</a></li>            
          </ul>
        </div>
        <div className="footer-links"> 
          <h3>Important Links</h3>
          <ul>
            <li><a href="/courses">Courses</a></li> 
            <li><a href="/course/ntt-mttcourse">NTTCourse</a></li>
            <li><a href="/course/ptt-course">PTT Course</a></li>
            <li><a href="/course/results">Results</a></li>
            <li><a href="/awards">Awards & Honours</a></li>
            <li><a href="/course/admission">Admissions</a></li>            
            <li><a href="/competitions">Competitions</a></li>
          </ul>
        </div>

        {/* 3️⃣ Right: Contact Info */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <ul>
            <li>
              <FaMapMarkerAlt /> Indiranagar, Bangalore
            </li>
            <li>
              <FaPhoneAlt /> <a href="tel:+919886855700">+91 98868 55700</a>
            </li>
            <li>
              <FaEnvelope />{" "}
              <a href="mailto:info@niecce.com">info@niecce.com</a>
            </li>
          </ul>
           <img
             src={niecceLogo}
             alt="NIECCE teacher training institute logo"
             title="NIECCE teacher training institute"
             className="footer-logo-small"
           />
        </div>
      </div>

      {/* SEO Text Section */}
      <div className="footer-seo">
        <h4>Trusted Institute for Teacher Training in India</h4>
        <p>
          NIECCE offers internationally recognized{" "}
          <strong>Nursery, Montessori & Primary Teacher Training Courses</strong>{" "}
          with online and regular batches. Established in 2004, NIECCE has
          trained over <strong>8700+ students</strong> and partnered with{" "}
          <strong>280+ schools</strong> across India.  
          Our programs combine <em>theory and practical learning</em>, soft skill
          development, and <em>placement assistance</em> to prepare professional
          educators for modern classrooms.
        </p>
      </div>

      {/* Bottom Line */}
      <div className="footer-bottom">
        <p>© 2025 NIECCE — All Rights Reserved.</p>
        <div className="footer-policy">
          <a href="/terms-conditions">Terms & Conditions</a>
          <a href="/privacypolicy">Privacy Policy</a>
          <a href="/refund-policy">Refund Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
